// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

// Distinct from common/models/user, which is for non-self/API user models
class SelfUserRecord extends Immutable.Record({
  'access_granted_at': String(),
  ambassadorSsoUrl: String(), // Only populated by user-settings-controller actions!
  bio: null,
  birthday: null,
  category: String(),
  'created_at': String(),
  'display_name': String(),
  email: String(),
  experiments: Immutable.Map(),
  gender: String(),
  id: null,
  loggedIn: Boolean(),
  'photo_url': String(),
  providers: Immutable.Map(),
  'provider_info': Immutable.List(),
  rollouts: Immutable.Map(),
  'signup_context': String(),
  'user_type': String(),
  username: String()
}) {

  hasRollout(key) {
    // Bots don't get rollouts
    if (Immutable.Map.isMap(this.rollouts)) {
      return this.rollouts.has(key)
    }
    return false
  }

}

SelfUserRecord.reviver = keyedReviver(SelfUserRecord, {
  experiments: defaultReviver,
  providers: defaultReviver,
  'provider_info': defaultReviver,
  rollouts: defaultReviver
})

SelfUserRecord.propTypes = {
  'access_granted_at': PropTypes.string,
  ambassadorSsoUrl: PropTypes.string,
  bio: PropTypes.string,
  birthday: PropTypes.number,
  category: PropTypes.string,
  'created_at': PropTypes.string,
  'display_name': PropTypes.string,
  email: PropTypes.string,
  experiments: PropTypes.object,
  gender: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loggedIn: PropTypes.bool,
  'photo_url': PropTypes.string,
  providers: PropTypes.object,
  'provider_info': PropTypes.array,
  rollouts: PropTypes.object,
  'signup_context': PropTypes.string,
  'user_type': PropTypes.string,
  username: PropTypes.string
}

module.exports = SelfUserRecord
